import { render, staticRenderFns } from "./CardPurchaseRequestHistory.vue?vue&type=template&id=d6578f14&"
import script from "./CardPurchaseRequestHistory.vue?vue&type=script&lang=ts&"
export * from "./CardPurchaseRequestHistory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports